var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_512_548)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_512_548)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4508 30.95C19.5349 30.9833 19.6246 31.0003 19.7151 31C19.8762 30.9991 20.0323 30.9437 20.1579 30.8429L23.7293 27.9857C23.8135 27.9192 23.8816 27.8346 23.9287 27.7382C23.9756 27.6417 24.0003 27.5359 24.0008 27.4286V22.0071L26.7008 19.3143C27.4329 18.5864 28.0132 17.7203 28.4079 16.7664C28.8028 15.8124 29.0043 14.7896 29.0008 13.7571V12.4286C29.0008 12.0497 28.8503 11.6864 28.5824 11.4185C28.3145 11.1505 27.9511 11 27.5722 11H26.2436C25.2112 10.9966 24.1884 11.1981 23.2345 11.5929C22.2806 11.9877 21.4145 12.568 20.6865 13.3L17.9936 16H12.5722C12.4643 16.0014 12.3582 16.0271 12.2616 16.0754C12.1652 16.1236 12.0809 16.1931 12.0151 16.2786L9.15792 19.85C9.0782 19.9489 9.02625 20.0671 9.00742 20.1927C8.98858 20.3182 9.00355 20.4465 9.05078 20.5643C9.09743 20.6813 9.1742 20.784 9.2733 20.8617C9.3724 20.9395 9.49029 20.9897 9.61506 21.0071L14.6151 21.7214L14.8151 20.2929L11.0508 19.7571L12.9151 17.4286H18.2865C18.3805 17.4291 18.4737 17.4111 18.5607 17.3756C18.6477 17.3401 18.7269 17.2877 18.7936 17.2214L21.7008 14.3143C22.2957 13.7153 23.0036 13.2402 23.7833 12.9166C24.5631 12.5929 25.3993 12.427 26.2436 12.4286H27.5722V13.7571C27.5738 14.6014 27.408 15.4377 27.0843 16.2174C26.7606 16.9972 26.2855 17.705 25.6865 18.3L22.7793 21.2071C22.7132 21.2739 22.6608 21.353 22.6252 21.4401C22.5897 21.5271 22.5716 21.6203 22.5722 21.7143V27.0857L20.2579 28.95L19.7222 25.1857L18.2936 25.3857L19.0079 30.3857C19.0254 30.5105 19.0756 30.6284 19.1533 30.7275C19.2312 30.8267 19.3337 30.9034 19.4508 30.95Z",
    fill: "#ECCFA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.49 20.4964L12.7779 26.2085L13.7879 27.2185L19.5 21.5064L18.49 20.4964Z",
    fill: "#ECCFA0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_512_548",
    x: 8.99951,
    y: 11,
    width: 20.0015,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_512_548"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_512_548",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_512_548",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#975B9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B36996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E37790"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.45b16210d40ebccb0a76bfb660d9477f.svg";
export { ForwardRef as ReactComponent };